/**
 * Loading Component
 * Displays a loading spinner with customizable message
 */

import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

const LoadingSpinner = ({ 
  message = "Loading...", 
  size = "50px",
  strokeWidth = "4",
  className = "flex flex-column align-items-center justify-content-center min-h-screen"
}) => {
  return (
    <div className={className}>
      <ProgressSpinner 
        style={{ width: size, height: size }} 
        strokeWidth={strokeWidth} 
      />
      <p className="mt-3 text-600">{message}</p>
    </div>
  );
};

export default LoadingSpinner;